"use strict"

import React, { useState, useEffect } from "react"
import { getFormReducer } from "../../widgets/utils"
import SingleColumnForm, { SingleColumnConfirmationBody } from "../../widgets/SingleColumnForm"

export default function AddDCSTableModal(props) {
  const { source, unwatched_tables, uploadData, page_translation_id } = props
  const [timestamp_options, setTimestampOptions] = useState([])
  const [table_focus, setTableFocus] = useState({})

  useEffect(() => {
    if (Object.keys(table_focus).length > 0) {
      setTimestampOptions(unwatched_tables[table_focus])
    } else {
      setTimestampOptions([])
    }
  }, [table_focus])

  const select_table = (name) => {
    setTableFocus(name)
  }

  const initialState = {
    isLoading: false,
    source: source.name,
    name: "",
    description: "",
    timestamp_column: "",
  }

  const initialWarningState = {
    sourceWarn: false,
    nameWarn: false,
    descriptionWarn: false,
    timestamp_columnWarn: false,
  }

  const formReducer = getFormReducer(initialState, initialWarningState)

  const resources = [
    { label: "general.source", field: "source", type: "text", disabled: true },
    {
      label: "reactormanagement.dcstable",
      field: "name",
      type: "dropdown",
      options: Object.keys(unwatched_tables),
      on_select: (name) => select_table(name),
    },
    { label: "general.description", field: "description", type: "textarea" },
    {
      label: "reactormanagement.timestamp.column",
      field: "timestamp_column",
      type: "dropdown",
      options: timestamp_options,
      disabled: timestamp_options.length === 0,
    },
  ]

  return (
    <SingleColumnForm
      formReducer={formReducer}
      initialState={initialState}
      initialWarningState={initialWarningState}
      resources={resources}
      submitData={uploadData}
      ModalBody={SingleColumnConfirmationBody}
      confirmation_title={page_translation_id}
      {...props}
    />
  )
}
